import { UniversalMenuItem } from '@klv/molecules/universal-menu-item';
import { generateClassName } from '@klv/shared/utils/functions';

import * as menuItemStyles from '@klv/molecules/universal-menu-item/styles/universalMenuItem.module.scss';
import * as styles from './styles/list.module.css';

import type { IUniversalMenuItemWithCustomFields } from '@klv/shared/types';
import { gtmClick } from '../../utils';


const ConditionalDetails = ({ children, recursive }: { children: React.ReactNode; recursive: boolean; }) => {
  if (recursive) {
    return <details>{children}</details>;
  }

  return children;
};

const ConditionalSummary = ({ children, recursive }: { children: React.ReactNode; recursive: boolean; }) => {
  if (recursive) {
    return <summary>{children}</summary>;
  }

  return children;
};

export const List = ({
  callToAction = {
    text: '',
    url: '',
  },
  childItems = [],
  className,
  depth,
  drawerPosition = 'upper',
  eyebrow,
  id,
  label = '',
  menuStyle = 'default',
  parentLabel,
  recursive = false,
  type,
  width,
  url,
  button,
  ...rest
}: {
  className?: string;
  depth?: number;
  drawerPosition?: 'lower' | 'upper';
  menuStyle?: 'default' | 'drilldown';
  parentLabel?: string;
  recursive?: boolean;
  button?: {
    buttonUrl?: string;
    buttonText?: string;
  };
} & IUniversalMenuItemWithCustomFields) => {
  const isBanner = button && button?.buttonText;

  return (
    <li
      className={generateClassName([
        className,
        styles[drawerPosition],
        styles.list,
        type && styles[type],
        width && styles[width],
        menuStyle === 'drilldown' && styles.drilldown,
      ])}
      key={id}
    >
      <ConditionalDetails recursive={recursive}>
        <ConditionalSummary recursive={recursive}>
          {eyebrow && (<div className={generateClassName([styles.eyebrow, isBanner && styles.isBanner])}>{eyebrow}</div>)}
          {(label !== '#' && label !== '') && (
            <UniversalMenuItem
              as={url ? undefined : 'div'}
              className={generateClassName([styles.label, styles.item])}
              data-depth={depth}
              href={url}
              label={label}
              button={button}
              onClick={() => { gtmClick({ childItem: label, menuItem: parentLabel }); }}
              {...rest}
            />
          )}
        </ConditionalSummary>
        {childItems?.length > 0 && (
          <ul className={styles.childList}>
            {childItems.map(({ childItems: childChildItems = [], id: childId, label: childLabel, url: childHref, ...childRest }) => (
              <li key={childId}>
                {menuStyle === 'drilldown' && childChildItems.length > 0 ? (
                  <ul><List {...childRest} childItems={childChildItems} id={childId} label={childLabel} menuStyle={menuStyle} parentLabel={label} recursive={true} /></ul>
                ) : (
                  <UniversalMenuItem
                    className={generateClassName([type === 'visual_list' && menuItemStyles.visualList, styles.item])}
                    href={childHref}
                    label={type === 'visual_list' ? '' : childLabel}
                    onClick={() => { gtmClick({ childItem: childLabel, menuItem: parentLabel }); }}
                    {...childRest}
                  />
                )}
              </li>
            ))}
          </ul>
        )}
        {(callToAction.text && callToAction.url) && (
          <UniversalMenuItem
            className={styles.callToAction}
            href={callToAction.url}
            label={callToAction.text}
          />
        )}
      </ConditionalDetails>
    </li>
  );
};
